<h1 mat-dialog-title class="title-bar pcps-dialog-title">
    <span class="dialog-title">{{ title }}</span>
</h1>
<mat-dialog-content>
    <div class="dialog-message" [innerHTML]="message"></div>
    <div class="flex flex-col justify-start items-stretch gap-2.5" [formGroup]="accountForm">
        <p>
            To create an account in our auction system, please fill out the form provided below, then click the "Create" button. Please
            note that all values are required.
        </p>
        <form novalidate class="flex flex-col justify-start items-stretch gap-3">
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">First Name:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="firstName" placeholder="First Name" maxlength="50" />
                    @if (accountForm.controls.firstName.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">Last Name:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="lastName" placeholder="Last Name" maxlength="50" />
                    @if (accountForm.controls.lastName.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">Email:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="email" placeholder="Email Address" maxlength="150" />
                    @if (accountForm.controls.email.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    } @else if (accountForm.controls.email.errors?.['email']) {
                        <mat-error>Invalid email format.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">Password:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="password" placeholder="Password" type="password" />
                    @if (accountForm.controls.password.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    } @else if (accountForm.controls.password.errors?.['complexity']) {
                        <mat-error>Insufficient complexity.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="md:basis-1/4"></span>
                <div class="grow flex flex-col justify-start items-end">
                    <div class="flex justify-end items-center gap-2">
                        <mat-icon
                            [class.text-(--mat-sys-primary)!]="!accountForm.controls.password.errors?.['complexity']?.minLength"
                            [class.text-(--mat-sys-error)!]="!!accountForm.controls.password.errors?.['complexity']?.minLength"
                            >{{ !accountForm.controls.password.errors?.['complexity']?.minLength ? 'check' : 'cancel' }}</mat-icon
                        >
                        <div>Must be at least 7 characters.</div>
                    </div>

                    <div class="flex justify-end items-center gap-2">
                        <mat-icon
                            [class.text-(--mat-sys-primary)!]="!accountForm.controls.password.errors?.['complexity']?.missingUppercase"
                            [class.text-(--mat-sys-error)!]="!!accountForm.controls.password.errors?.['complexity']?.missingUppercase"
                            >{{
                                !accountForm.controls.password.errors?.['complexity']?.missingUppercase ? 'check' : 'cancel'
                            }}</mat-icon
                        >
                        <div>Must have at least one upper-case letter.</div>
                    </div>

                    <div class="flex justify-end items-center gap-2">
                        <mat-icon
                            [class.text-(--mat-sys-primary)!]="!accountForm.controls.password.errors?.['complexity']?.missingLowercase"
                            [class.text-(--mat-sys-error)!]="!!accountForm.controls.password.errors?.['complexity']?.missingLowercase"
                            >{{
                                !accountForm.controls.password.errors?.['complexity']?.missingLowercase ? 'check' : 'cancel'
                            }}</mat-icon
                        >
                        <div>Must have at least one lower-case letter.</div>
                    </div>

                    <div class="flex justify-end items-center gap-2">
                        <mat-icon
                            [class.text-(--mat-sys-primary)!]="!accountForm.controls.password.errors?.['complexity']?.missingNumber"
                            [class.text-(--mat-sys-error)!]="!!accountForm.controls.password.errors?.['complexity']?.missingNumber"
                            >{{ !accountForm.controls.password.errors?.['complexity']?.missingNumber ? 'check' : 'cancel' }}</mat-icon
                        >
                        <div>Must have at least one digit.</div>
                    </div>
                </div>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">Verify Password:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="password2" placeholder="Repeat Password" type="password" />
                    @if (accountForm.controls.password2.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    }
                </mat-form-field>
            </div>
            @if (
                accountForm.errors?.['verifyMismatch'] &&
                accountForm.controls.password.touched &&
                accountForm.controls.password2.touched
            ) {
                <mat-error>Passwords do not match.</mat-error>
            }
        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button class="cancelbtn" [class.cancel-button]="classicCancel" [mat-dialog-close]="null">
        <span>{{ canceltext }}</span>
    </button>
    <button mat-flat-button class="okbtn" (click)="OKHandler()">
        <span>{{ oktext }}</span>
    </button>
</mat-dialog-actions>
